import { useTranslation } from 'react-i18next';

import { useAgencyConfiguration } from '@/app/shell/agencyConfiguration';
import { LanguageSelector, NgPageHeader } from '@/ui';

import { ApplicationRefresh } from './ApplicationRefresh';
import { PushSubscription } from './PushSubscription';
import { hasEnabledPushNotifications } from './pushNotificationTypes';
import type { PushNotificationConfiguration } from './pushNotificationTypes';

export function SettingsPage() {
  const { t } = useTranslation();
  const agencyConfiguration = useAgencyConfiguration();
  const pageTitle = t('PageTitle_Settings');

  const pushNotificationConfiguration = agencyConfiguration.notificationConfiguration
    ?.pushNotificationConfiguration as PushNotificationConfiguration | null | undefined;

  return (
    <div className="content p-3">
      <NgPageHeader title={pageTitle} />
      <h1 className="mb-4">{pageTitle}</h1>

      <div className="d-flex flex-column gap-4">
        <div>
          <LanguageSelector />
        </div>

        {hasEnabledPushNotifications(pushNotificationConfiguration) && (
          <div>
            <PushSubscription configuration={pushNotificationConfiguration} />
          </div>
        )}

        <div>
          <ApplicationRefresh />
        </div>
      </div>
    </div>
  );
}
